import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/index";
import { createBootstrap } from "bootstrap-vue-next";
import VueApexCharts from "vue3-apexcharts";
import { QuillEditor } from "@vueup/vue-quill";
import { authStore } from "./stores/auth"; // Import the auth store
import { loadFromCSV } from "./utils/i18nHelper"; // Import loadFromCSV

import "@vueup/vue-quill/dist/vue-quill.snow.css";
import "@vueup/vue-quill/dist/vue-quill.bubble.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import "swiper/css";
import "swiper/css/bundle";
import "swiper/css/pagination";
import "swiper/css/navigation";


import "./assets/css/remixicon.css";
import "./assets/css/sidebar-menu.css";
import "./assets/css/simplebar.css";
import "./assets/css/debug-styles.css";
import "./assets/scss/style.scss";
import "./utils/clipboardHelper";

// Function to fetch and load translations
async function fetchAndLoadTranslations() {
  try {
    const response = await fetch("/forfettario-i18n-keys.csv");
    const csvText = await response.text();

    const parsedData = csvText.split(/\r?\n/)
      .filter(line => line.trim() !== '' && !line.startsWith('key,'))
      .map(line => {
        // Regex to capture key and the content of the second field (testo_attuale),
        // handling quoted strings.
        const match = line.match(/^([^,]+),"([^"]*)",?.*$/);
        if (match) {
          return {
            key: match[1],
            testo_tradotto: match[2]
          };
        }
        // Fallback for lines without quotes in the second field, or other formats
        const parts = line.split(',');
        return {
          key: parts[0],
          testo_tradotto: parts[1]
        };
      });
    loadFromCSV(parsedData.filter(item => item.key && item.testo_tradotto)); // Filter out any malformed entries
  } catch (error) {
    console.error("Failed to load translations:", error);
  }
}

// Wait for the auth check to complete before creating and mounting the app
authStore.checkAuth().then(async () => { // Make this async
  await fetchAndLoadTranslations(); // Load translations before mounting the app
  const app = createApp(App).use(router);
  app.use(createBootstrap());
  app.use(VueApexCharts as any);
  app.component("QuillEditor", QuillEditor);
  app.mount("#app");
});
